<template>
    <div>
        <div class="inv-box">
            <span class="normal-span" tkey="我的邀請碼">{{i18n.tkey('lang_my_invcode')}}</span>：<shopInvitionSpan />
        </div>

<!--        <div>-->
<!--            <el-button style="width: 100%" @click="goInvRecord" tkey="我的邀請">{{i18n.tkey('lang_my_inv')}}</el-button>-->
<!--        </div>-->
    </div>
</template>

<script setup>
    import shopInvitionSpan from "@/components/shopopee/shop/shopInvitionSpan"
    import {inject} from "vue";

    const emits = defineEmits(['goInvRecord'])

    const i18n = inject("i18n")

    // function goInvRecord() {
    //     emits("goInvRecord")
    // }
</script>

<style scoped>
    .inv-box {
        text-align: left;
        line-height: 2.5;
    }

    .normal-span {
        font-size: 14px;
        color: #303133;
    }
</style>